import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { SubSink } from 'subsink';
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { TimetableDataService } from '../timetable-data.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-timetable-months',
  templateUrl: './timetable-months.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TimetableMonthsComponent implements OnInit, OnDestroy {
  public timeTableData$: Observable<any>;
  public readonly timeTableDataService = inject(TimetableDataService);
  public readonly faCircleInfo = faCircleInfo;

  private readonly subs = new SubSink();

  ngOnInit(): void {
    this.timeTableData$ = this.timeTableDataService.loadTimeTableMonthlyData();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
